module.exports = __webpack_public_path__ + "static/media/AutoFitHeight.17b37715.svg";